import React from "react";
import * as Yup from "yup";
import yupSchema from "../../../constants/schema";
import { useErrorHandler } from "../../../hooks";
import DialogFormBuilder from "../../../components/dialog-form-builder";
import colorsService from "../../../services/colors.service";

const initialValues = {
  name: "",
  color: "",
  image: "",
};
const schema = Yup.object().shape({
  name: yupSchema.name,
  color: yupSchema.optionalColorHex,
});
const form = [
  {
    _type: "textField",
    name: "name",
    label: "نام",
    autoFocus: true,
  },
  {
    _type: "textField",
    name: "color",
    label: "رنگ",
  },
  {
    _type: "filePicker",
    name: "image",
    label: "عکس",
    isImage: true,
  },
];

export default function FormModalContent({ close, data, extra }) {
  const errorHandler = useErrorHandler();

  const handleSubmit = async (model, { setSubmitting }) => {
    let op;
    if (data?.id) {
      op = await colorsService.editColor(data.id, model);
    } else {
      op = await colorsService.createColor(model);
    }
    const { error } = op;
    setSubmitting(false);
    if (error) return errorHandler(error);

    close(true);
  };
  return (
    <DialogFormBuilder
      {...{
        close,
        name: "رنگ",
        data,
        schema,
        initialValues,
        handleSubmit,
        form,
      }}
    />
  );
  // return (
  //   <Loading isLoading={waiting} overlay>
  //     <DialogTitle onClose={() => close()}>
  //       {id ? "ویرایش عینک" : "ایجاد عینک"}
  //     </DialogTitle>
  //     <Divider />
  //     <Formik
  //       initialValues={id ? initialValues : emptyValues}
  //       onSubmit={handleSubmit}
  //       validationSchema={formSchema}
  //     >
  //       {({ isSubmitting, values }) => (
  //         <Form autoComplete="off">
  //           <DialogContent>
  //             <FTextField name="name" label="نام" autoFocus />
  //             <FTextField name="summery" label="خلاصه توضیحات"  />
  //             <FTextField name="description" label="توضیحات" />
  //             <FTextField name="weight" label="وزن" type="number" />
  //           </DialogContent>
  //           <DialogActions>
  //             <Button onClick={close} color="primary" disabled={isSubmitting}>
  //               لغو
  //             </Button>
  //             <Button
  //               type="submit"
  //               disabled={isSubmitting}
  //               variant="contained"
  //               color="primary"
  //             >
  //               {id ? "ذخیره" : "ایجاد"}
  //             </Button>
  //           </DialogActions>
  //         </Form>
  //       )}
  //     </Formik>
  //   </Loading>
  // );
}
